import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2024 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { LogUtils } from "abweb/utils/log/LogUtils";
export class AbSessionStorage {
  /**
   * Wrapper around session storage. Handles QuotaExceededError exceptions by providing some context about the failure.
   * See MH-1736 / MH-30082 for more details.
   */
  static setItem(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch (e) {
      // Throws QuotaExceededError
      const error = e;
      if (error?.name === "QuotaExceededError") {
        AbSessionStorage.LOG.debug("QuotaExceededError trying to call sessionStorage.setItem");
        AbSessionStorage.LOG.debug("Exception:");
        AbSessionStorage.LOG.error(error.message);
        AbSessionStorage.LOG.debug("Key attempting to be written to:");
        AbSessionStorage.LOG.debug(key);
        AbSessionStorage.LOG.debug("Value attempting to be written:");
        AbSessionStorage.LOG.debug(value);
        AbSessionStorage.LOG.debug("Session Storage information:");
        // Write out session storage to console.
        let _lsTotal = 0,
          _xLen,
          _x;
        for (_x in sessionStorage) {
          if (!sessionStorage.hasOwnProperty(_x)) {
            continue;
          }
          _xLen = (sessionStorage[_x].length + _x.length) * 2;
          _lsTotal += _xLen;
          AbSessionStorage.LOG.debug(_x.substring(0, 50) + " = " + (_xLen / 1024).toFixed(2) + " KB");
        }
        AbSessionStorage.LOG.debug("Total = " + (_lsTotal / 1024).toFixed(2) + " KB");
      }

      // Not an expected error, so throw.
      throw e;
    }
  }
  static getItem(key) {
    return sessionStorage.getItem(key);
  }
  static removeItem(key) {
    sessionStorage.removeItem(key);
  }
}
_defineProperty(AbSessionStorage, "LOG", LogUtils.getLogger(__filename));
//# sourceMappingURL=AbSessionStorage.js.map
